window.addEventListener('smile:load-async-script', () => {
    const waitForSmile = setInterval(() => {
        const smileParent = document.getElementById('smile-ui-container')
        if ( !!!smileParent ) return
        
        smileParent.style.zIndex = '998'
        clearInterval(waitForSmile)
    }, 250);
})

const plpAtcHandling = () => {
    if ( !location.pathname.includes('/collections/') ) return

    document.addEventListener('click', ({ target }) => {
        const isPlpAtc = target.closest('[data-atc-plp]')
        if ( !!!isPlpAtc ) return

        const bakText = isPlpAtc.textContent
        isPlpAtc.textContent = 'Adding...'

        setTimeout(() => isPlpAtc.textContent = bakText, 1500)
    })
}

const stickyHeader = () => {
    // STICKY HEADER 
    const stickyConfig = {
        sectionHeader: document.querySelector('#shopify-section-header'),
        siteHeader: document.querySelector('[data-header-section]'),
        stickyEnabledClass: 'header-wrapper--sticky',
        stickyEnabled: false,
        stickyActive: false,
        stickyInitialized: false,
        forceStopSticky: false,
        stickyClass: 'site-header--stuck',
        stickyClassOpened: 'header-sticky--opened',
        openTransitionClass: 'site-header--opening',
        lastScroll: 0
    };

    // When page is loaded -> Set height of header and set scroll listener
    stickyHeaderHeight()
    window.addEventListener('resize', () => stickyHeaderHeight(true))

    function stickyHeaderScroll(){
        if (!stickyConfig.siteHeader) return

        const threshold = 230;
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;    

        if (currentScroll > threshold) {
            if (stickyConfig.forceStopSticky) {
                return;
            }
        
            stickyConfig.stickyActive = true;
        
            stickyConfig.siteHeader.classList.add(stickyConfig.stickyClass);
            // Add open transition class after element is set to fixed
            // so CSS animation is applied correctly
            setTimeout(function() {
                stickyConfig.siteHeader.classList.add(stickyConfig.openTransitionClass);
            }, 10);

            return
        }

        stickyConfig.siteHeader.classList.remove(stickyConfig.openTransitionClass)
        stickyConfig.siteHeader.classList.remove(stickyConfig.stickyClass)
    }

    function stickyHeaderHeight(isResize = false) {
        const height = stickyConfig.siteHeader.clientHeight;
        document.querySelector('.site-header--sticky').style.height = `${height}px`;
        if(!isResize) window.addEventListener('scroll', stickyHeaderScroll)
    }
}

const mobileMegamenu = () => {
    const linksWithNavigation = [...document.querySelectorAll('[data-has-submenu]')];
    const allMegamenu = [...document.querySelectorAll('.megamenu-custom')];
    const backLevel = [...document.querySelectorAll('[data-back-level]')];

    if(linksWithNavigation.length > 0 && allMegamenu.length > 0) {
        linksWithNavigation.forEach(link => {
            link.addEventListener('click', (evt) => {
                evt.preventDefault();
                evt.stopPropagation();

                const dataTitle = evt.target.dataset.hasSubmenu || evt.target.parentElement.dataset.hasSubmenu
                
                if (dataTitle) showSecondLevel(dataTitle)
            })
        })
    }

    if (backLevel.length > 0) backLevel.forEach(arrowBack => arrowBack.addEventListener('click', hideSecondLevel))

    function showSecondLevel(dataTitle) {
        const menuMatched = allMegamenu.find(menu => menu.dataset.linkTitle === dataTitle)

        if(menuMatched) {
            hideSecondLevel()
            menuMatched.classList.add('megamenu-active');
        }
    }

    function hideSecondLevel() {
        allMegamenu.forEach(item => item.classList.remove('megamenu-active'))
    }
}



const togglePlpMobileFilters = () => {
    const mobileFiltersSidebar = document.getElementById('FilterByGroup');

    mobileFiltersSidebar.classList.toggle('active');

    if (mobileFiltersSidebar) {
        if (mobileFiltersSidebar.classList.contains('active')) {
            bodyScrollLock.lock(mobileFiltersSidebar);
        } else {
            bodyScrollLock.unlock(mobileFiltersSidebar);
        }   
    }
}

const removenbsp = () => {
    
    const listsdf = document.getElementsByClassName("box-includes")[0];
    if (listsdf) {
        const googcon = listsdf.getElementsByTagName("p")[0].innerHTML;
        let newStr = googcon.replace(/&(nbsp|amp|quot|lt|gt);/g,"");
        listsdf.getElementsByTagName("p")[0].innerHTML=newStr;
        document.getElementsByClassName("box-includes")[0].style.display = 'block';
    }
}
document.addEventListener('DOMContentLoaded', () => {
    plpAtcHandling()
    stickyHeader()
    mobileMegamenu()
    removenbsp()

})

window.addEventListener('htmx:afterSwap', () => {
    bodyScrollLock.clearBodyLocks();
});

/***footer accordion**/
window.addEventListener('load', function() {
    let win = this;
    
    if (win.innerWidth < 800) {
     
        var i;

        var accItem = document.getElementsByClassName('accordion');
            var accHD = document.getElementsByClassName('acc-summary');
            for (i = 0; i < accHD.length; i++) {
                accHD[i].addEventListener('click', toggleItem, false);
            }
            function toggleItem() {
                
                var itemClass = this.parentNode.className;
                for (i = 0; i < accItem.length; i++) {
                    accItem[i].className = 'accordion';
                }
                if (itemClass == 'accordion') {
                    this.parentNode.className = 'accordion active';
                } 
            }
      
    } else {
    
    }
});
